import { useQuery } from '@apollo/client';

import { GetLanguageDocument } from '../graphql/get-language.gql-types';

export type UseLanguage = {
  loadingLanguage: boolean;
  language: string | undefined;
};

type UseLanguageOptions = {
  skip?: boolean;
};

export function useLanguage(options: UseLanguageOptions = {}): UseLanguage {
  const { skip = false } = options;
  const { loading: loadingLanguage, data } = useQuery(GetLanguageDocument, {
    skip,
  });

  return {
    loadingLanguage: skip ? false : loadingLanguage,
    language: data?.viewer?.accountSettings?.language?.value,
  };
}
